import { defineStore } from 'pinia'

export const Reg_Documents = defineStore({
    id: 'wp_docs__registered',
    state: () => {
        return { value: null }
    },
    actions: {
        get() {
            return this.value
        },
        set(data) {
            this.value = data
        }
    },
})

export const App_Documents = defineStore({
    id: 'wp_docs__appeals',
    state: () => {
        return { value: null }
    },
    actions: {
        get() {
            return this.value
        },
        set(data) {
            this.value = data
        }
    },
})
